module.exports = {
  entry: './src/apps/sevone-benefits-calculator/index.tsx',
  shortcode: 'sevone-benefits-calculator',
  title: 'SevOne Benefits Calculator',
  status: 'stable',
  description: 'Allows users to calculate putage avoidance benefits.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-sevone-benefits-calculator-components--default&viewMode=story`,
  },
  settingsSchema: {
    type: 'object',
    properties: {
      fields: {
        type: 'object',
        required: ['override_percentage'],
        properties: {
          override_percentage: {
            type: 'string',
            title: 'Override Percentage',
            description: 'need to come up with this',
            default: '10',
            items: {
              type: 'string',
              pattern: '^[a-zA-Z0-9_.]+$',
            },
            examples: [['20']],
          },
        },
      },
    },
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/file-transfer-calculator'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    org: 'digitalsales', // to filter the widget
    widgetLocation: '/benefits-calculator', // default '/pricing' but sometimes
    productName: 'sevone', // the product name in the URL.
    activatedCountryPages: ['us-en'],
    brand: 'automation',
  },
};
